import React from 'react';
import { observer } from 'mobx-react';
import NoState from '../no-state';
import './index.scss';
import { getRadarState } from '../../../../js/utils';

function GeoBroadcastCard(props) {
  const store = props.store;
  const last = store.lastList;
  let lastState = '';
  if (last) {
    lastState = last.state === 1 ? '有车' : '无车';
  }

  return (
    <div className={['geo-broadcast-card', store.disabled ? 'disabled' : ''].join(' ')} onClick={props.onClick}>
      <div className="gbc-header">
        <div>车位号 {store.parkingno}</div>
        <div>mac：{store.mac}</div>
      </div>
      <div className="gbc-content">
        {
          store.list.length > 0 ? (
            <div className="gbc-body">
              <div className="gbc-body-state">
                <div className="left">
                  <div>检测时间：{last.detectTime}</div>
                  <div>雷达状态：<span className="emphasis">{getRadarState(last.radarState)}</span></div>
                  <div>上传耗时：<span className="emphasis">{last.millis}s</span></div>
                </div>
                <div className={['right', last.state === 1 ? 'has-car' : 'no-car'].join(' ')}>
                  <div>{lastState}</div>
                </div>
              </div>
              <div className="gbc-foot">
                <div className="gbc-foot-title"><span>实时状态</span></div>
                <div className="gbc-foot-state">
                  <div>雷达状态：{getRadarState(store.currentRadarState)}</div>
                  <div>rssi：{store.rssi}</div>
                  <div>检测时间：{store.receiveTime}</div>
                </div>
              </div>
            </div>
          ) : <NoState text="暂未收到状态变化" card />
        }
      </div>
    </div>
  );
}

export default observer(GeoBroadcastCard);
